import { path } from 'ramda';
import {
  IGetOfferFromHistoryWebOptions,
  IGetOfferFromHistoryWebResponse,
  IGetOfferFromHistoryWebResponse200,
  IGetOfferFromHistoryWebResponse400,
  IGetOfferFromHistoryWebResponseError,
  fetchGetOfferFromHistoryWeb,
} from 'shared/repositories/valuation-offer-history/v2/get-offer-from-history-web';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TOfferFromHistoryData } from 'shared/types/offersHistory';
import { request } from 'shared/utils/request';
import { assertAuthRequiredError, assertResponseError } from 'shared/utils/errors';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';

type TParameters = TRequestParamsWithoutHttpApi<
  IGetOfferFromHistoryWebOptions<IGetOfferFromHistoryWebResponse200, IGetOfferFromHistoryWebResponse400>
>;

export const fetchOfferFromHistory = async (
  context: IApplicationContext,
  parameters: TParameters,
): Promise<TOfferFromHistoryData> =>
  request<TOfferFromHistoryData, TParameters, IGetOfferFromHistoryWebResponse, IGetOfferFromHistoryWebResponseError>(
    context,
    {
      parameters,
      domain: 'fetchOfferFromHistory',
      fetchFunction: fetchGetOfferFromHistoryWeb,
      errorHandler,
    },
  );

export function errorHandler(domain: string, response: IGetOfferFromHistoryWebResponseError): Error {
  if (path([0, 'key'], response.errors) === 'auth') {
    return assertAuthRequiredError(domain, response);
  }

  return assertResponseError(domain, response);
}
